<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<!-- Mobile App Download Banner -->


<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="main-header" [ngClass]="{'main-header-four':base==='index-2' || base==='index-4' || base==='index-6'}">
<div *ngIf="!isAppBannerClosed" class="app-download-banner d-lg-none position-sticky top-0" style="z-index: 50; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
    <div class="container-fluid p-0">
        <div class="d-flex align-items-center text-white position-relative" style="min-height: 60px;">
            <!-- App Icon and Text -->
            <div class="d-flex align-items-center flex-grow-1 px-3">
                <!-- <div class="me-3" style="background: rgba(255,255,255,0.2); border-radius: 12px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                    <i class="fab fa-android" style="font-size: 20px; color: #4CAF50;"></i>
                </div> -->
                <div class="flex-grow-1">
                    <div style="font-weight: 600; font-size: 14px; line-height: 1.2;">BookATravel.com App</div>
                    <div style="font-size: 12px; opacity: 0.9; line-height: 1.2;">Quick and easy travel bookings!</div>
                </div>
            </div>

            <!-- Install Button -->
            <div class="px-2">
                <button class="btn btn-light btn-sm fw-bold px-3"
                        (click)="downloadAPK()"
                        style="border-radius: 20px; font-size: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
                    INSTALL
                </button>
            </div>

            <!-- Close Button -->
            <div class="px-3">
                <button class="btn p-0 text-white"
                        (click)="closeAppBanner()"
                        style="background: none; border: none; font-size: 18px; opacity: 0.8; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    ×
                </button>
            </div>
        </div>
    </div>
</div>
    <app-header-top-bar
      [base]="base"
      [page]="page"
      [isdark]="isdark"
      [islight]="islight"
      (darkMode)="darkMode()"
    ></app-header-top-bar>
    <header [ngClass]="{ 'header-three': base === 'index-3', 'header-four': base === 'index-4'|| base === 'index-2', 'header-five': base === 'index-5' , 'header-six': base === 'index-6','fixed': isFixed }">
        <div [ngClass]="base ==='index-4' ? 'container-fluid' : 'container'">
            <div class="offcanvas-info" [ngClass]="{ 'show': show }">
                <div class="offcanvas-wrap">
                    <div class="offcanvas-detail">
                        <div class="offcanvas-head">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <a [routerLink]="routes.index" class="black-logo-responsive">
                                    <img src="assets/img/logo.png" alt="logo-img">
                                </a>
                                <a [routerLink]="routes.index" class="white-logo-responsive">
                                    <img src="assets/img/logo.png" alt="logo-img">
                                </a>
                                <div class="offcanvas-close" (click)="closeMenu()">
                                    <i class="ti ti-x"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Navigation Links Section -->
                        <div class="mobile-nav-links mb-4">
                            
                            <!-- APK Download for Mobile -->
                            <div class="nav-link-item mb-3 d-none">
                                <a href="javascript:void(0);"
                                   (click)="downloadAPK(); closeMenu()"
                                   class="btn btn-success w-100 d-flex align-items-center justify-content-center position-relative"
                                   style="background: linear-gradient(135deg, #28a745, #20c997); border: none; font-weight: bold; box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);">
                                    <i class="fab fa-android me-3 fs-5"></i>
                                    <div class="text-start">
                                        <div style="font-size: 14px;">Download Our</div>
                                        <div style="font-size: 12px; opacity: 0.9;">Android App</div>
                                    </div>
                                    <!-- New badge for mobile -->
                                    <span class="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger" style="font-size: 10px;">
                                        NEW
                                    </span>
                                </a>
                            </div>

                            <div class="nav-link-item mb-2">
                                <a href="javascript:void(0);" class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-start" (click)="navigateOrReload('flight'); closeMenu()">
                                    <i class="fas fa-plane me-3"></i>
                                    <span>Flights</span>
                                </a>
                            </div>
                            <div class="nav-link-item mb-2">
                                <a href="javascript:void(0);" class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-start" (click)="navigateOrReload('hotels'); closeMenu()">
                                    <i class="fas fa-hotel me-3"></i>
                                    <span>Hotels</span>
                                </a>
                            </div>
                            <div class="nav-link-item mb-2">
                                <a href="javascript:void(0);" class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-start" (click)="navigateOrReload('cars'); closeMenu()">
                                    <i class="fas fa-car me-3"></i>
                                    <span>Cars</span>
                                </a>
                            </div>
                            
                        </div>
                        <!-- <div class="mobile-menu fix mb-3" [ngClass]="{ 'mean-container': isMobileMenu }">
                            <div class="mean-bar">
                            <a href="#nav" class="meanmenu-reveal" style="right: 0px; left: auto; display: inline;">
                            <span><span>
                                <span></span>
                            </span></span>
                            </a>
                            <nav class="mean-nav">
                            <ul class="main-nav" style="display: none;" [ngClass]="{'active' : isDropdownOpen}">
                                <ng-container *ngFor="let mainMenus of header, let i = index">
                                <ng-container *ngIf="mainMenus.separateRoute === true">
                                <li class="has-submenu megamenu active" [ngClass]="{'dropdown-opened' : isDropdownOpen}">
                                    <a href="javascript:void(0);">
                                        {{mainMenus.tittle}}
                                        <i class="fa-solid fa-plus"></i>
                                    </a>
                                    <ul class="submenu mega-submenu" [ngStyle]="{ display: isDropdownOpen ? 'block' : 'none' }">

                                        <li>
                                            <div class="megamenu-wrapper">
                                                <div class="d-none d-lg-flex align-items-center justify-content-between flex-wrap">
                                                    <h6 class="mb-3">Home Pages</h6>
                                                    <a href="javascript:void(0);" class="btn btn-dark btn-md mb-3 text-white d-inline-block w-auto">Purchase Template</a>
                                                </div>
                                                <div class="row g-lg-4">
                                                    <ng-container *ngFor="let menu of mainMenus.menu">
                                                        <div class="col-lg-2">
                                                            <div class="single-demo" [class.active]="base === menu.base">
                                                                <div class="demo-img">
                                                                    <a [routerLink]="menu.route"><img [src]="menu.img" class="img-fluid" alt="img" /></a>
                                                                </div>
                                                                <div class="demo-info">
                                                                    <a [routerLink]="menu.route">{{menu.homeName}}</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </ng-container>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                <a class="mean-expand" href="javascript:void(0);" style="font-size: 18px" [ngClass]="{'mean-clicked' : isDropdownOpen}" (click)="openSubMenu()"><i class="ti ti-plus"></i></a>
                                </li>
                                </ng-container>
                                <ng-container *ngIf="mainMenus.separateRoute === false">
                                <li class="has-submenu mega-innermenu" [class.active]="base === mainMenus.base || page===mainMenus.base" [ngClass]="{'dropdown-opened' : openDropdownIndex === i}">
                                    <a href="javascript:void(0);">{{mainMenus.tittle}}<i class="fa-solid fa-plus"></i></a>
                                    <ul class="submenu mega-submenu" [ngStyle]="{ display: openDropdownIndex === i ? 'block' : 'none' }">
                                        <li>
                                            <div class="megamenu-wrapper">
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <h6>{{mainMenus.tittle}}</h6>
                                                        <ul style="display: none;">
                                                            <ng-container *ngFor="let menu of mainMenus.menu">
                                                                <ng-container *ngIf="mainMenus.twoTitle === false">
                                                                <li><a  href="javascript:void(0)">{{menu.menuValue}}</a></li>
                                                            </ng-container>
                                                            <ng-container *ngIf="mainMenus.twoTitle === true">
                                                                <ng-container *ngIf="menu.menuValue">
                                                                    <li><a  href="javascript:void(0)">{{menu.menuValue}}</a></li>
                                                                </ng-container>
                                                            </ng-container>
                                                            <ng-container *ngIf="mainMenus.twoTitle === true">
                                                                <ng-container *ngIf="menu.menuValue2">
                                                                <li><a  href="javascript:void(0)">{{menu.menuValue2}}</a></li>
                                                                </ng-container>
                                                            </ng-container>
                                                            </ng-container>
                                                        </ul>
                                                    <a class="mean-expand" href="javascript:void(0);" style="font-size: 18px"><i class="ti ti-plus"></i></a></div>
                                                    <div class="col-lg-6">
                                                        <div class="menu-img">
                                                            <img src="assets/img/menu/flight.jpg" alt="img" class="img-fluid">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                <a class="mean-expand" href="javascript:void(0);" style="font-size: 18px" [ngClass]="{'mean-clicked' : openDropdownIndex === i}" (click)="toggleSubMenu(i)"><i class="ti ti-plus"></i></a>
                                </li>
                            </ng-container>
                                </ng-container>
                            </ul>
                        </nav>
                        </div>
                        </div> -->
                         <ng-container *ngIf="(authService.isLoggedIn$ | async) === false; else mobileAuthenticatedMenu">
                                  <div><a href="javascript:void(0);" class="text-white btn btn-dark w-100 mb-3" (click)="openModel()">Sign In</a></div>
                                </ng-container>
                        <div class="offcanvas__contact">
                            <div class="mt-4">
                                <!-- Country/Currency Dropdown Section -->
                                <div class="header-dropdown d-flex flex-fill mb-3">
                                    <div class="w-100">
                                        <div class="dropdown country-dropdown mb-2">
                                            <a href="javascript:void(0);" class="dropdown-toggle bg-white border d-flex align-items-center p-2 rounded" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="fas fa-globe me-2"></i>
                                                {{ selectedCountryLabel }}
                                                <i class="fas fa-chevron-down ms-auto"></i>
                                            </a>
                                            <ul class="dropdown-menu p-2 w-100">
                                                <li *ngFor="let info of supportedInfo">
                                                    <a class="dropdown-item rounded d-flex align-items-center"
                                                       href="javascript:void(0);"
                                                       [class.active]="info.id === selectedCountryId"
                                                       (click)="onCountryChangeDropdown(info.id)">
                                                        <i class="fas fa-language me-2"></i>
                                                        {{ info.currency }}
                                                        <small class="ms-auto text-muted">{{ getHotelLanguageName(info.hotelLanguage) || info.hotelLanguage }}</small>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!-- <a [routerLink]="routes.becomeAnExpert" class="btn btn-primary w-100">Become Expert</a> -->
                                 <div class="nav-link-item mb-2">
                                <i class="fa-brands fa-whatsapp me-2 text-success"></i>
  <a href="https://wa.me/310623010197" target="_blank" class="text-decoration-none text-dark">
    WhatsApp : +31 0623010197
  </a>
                            </div>
                            <div class="nav-link-item mb-2">
<i class="isax isax-message-text-15 me-2"></i>Email : info&#64;bookatravel.com
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="offcanvas-overlay" [ngClass]="{ 'overlay-open': show }" (click)="closeMenu()"></div>
            <div class="header-nav">
                <div class="main-menu-wrapper">
                    <div class="navbar-logo d-flex align-items-center justify-content-between w-100">
                                                <div class="d-flex align-items-center gap-4">
                                                        <a class="logo-white header-logo" [routerLink]="routes.index">
                                                                <img [src]=" base==='index-2' || base==='index-3' || base==='index-4' || base==='index-5'? 'assets/img/logo.png' :'assets/img/logo.png'" class="logo" alt="Logo">
                                                        </a>
                                                        <a [hidden]="base==='index-6'" class="logo-dark header-logo" [routerLink]="routes.index">
                                                                <img src="assets/img/logo.png" class="logo" alt="Logo">
                                                        </a>
                                                </div>
                                                <nav class="main-nav d-none d-lg-flex flex-grow-1 justify-content-center" aria-label="Primary">
                                                    <ul class="nav gap-3">
                                                        <li>
                                                            <a href="javascript:void(0);" class="nav-link" [ngClass]="isFixed ? 'text-dark' : 'text-white'"
                                                                 (click)="navigateOrReload('flight')">Flights</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" class="nav-link" [ngClass]="isFixed ? 'text-dark' : 'text-white'"
                                                                 (click)="navigateOrReload('hotels')">Hotels</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" class="nav-link" [ngClass]="isFixed ? 'text-dark' : 'text-white'"
                                                                 (click)="navigateOrReload('cars')">Cars</a>
                                                        </li>
                                                    </ul>
                                                </nav>

                        <!-- Desktop Authentication Menu -->
                        <div class="d-none d-lg-flex align-items-center">
                            <!-- APK Download Section -->
                            <div class="me-3">
                                <a href="javascript:void(0);"
                                   (click)="downloadAPK()"
                                   class="btn btn-success btn-sm d-flex align-items-center position-relative"
                                   title="Download Android App">
                                    <i class="fab fa-android me-2"></i>
                                    <span class="d-none d-xl-inline">Download App</span>
                                    <span class="d-xl-none">App</span>
                                    <!-- Optional: Add a small badge to indicate it's new -->
                                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 8px;">
                                        NEW
                                    </span>
                                </a>
                            </div>

                            <span  *ngIf="['index', 'pages'].includes(base); else defaultheader">
                             <div *ngIf="base === 'index'" class="header-btn d-flex align-items-center">
                                 <div class="me-3">
                                     <!-- Theme toggles if needed -->
                                 </div>
                                  <ng-container *ngIf="(authService.isLoggedIn$ | async) === false; else authenicatedMenu">
                                    <div><a href="javascript:void(0);" class="btn btn-white me-3" (click)="openModel()">Sign In</a></div>
                                  </ng-container>
                             </div>
                             <div *ngIf="page==='index-rtl'" class="rtl header-btn d-flex align-items-center">
                                  <ng-container *ngIf="(authService.isLoggedIn$ | async) === false; else authenicatedMenu">
                                    <div class="btn btn-white ms-3"><a href="javascript:void(0);" (click)="openModel()">Sign In</a> / <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#register-modal">Sign Up</a></div>
                                  </ng-container>
                             </div>
                         </span>
                         <ng-template #defaultheader >
                             <div *ngIf="base !== 'index' || page !=='index-rtl'" class="header-btn d-flex align-items-center" >
                                 <ng-container *ngIf="(authService.isLoggedIn$ | async) === false; else authenicatedMenu">
                                   <div><a href="javascript:void(0);" class="btn btn-white me-3" (click)="openModel()">Sign In</a></div>
                                 </ng-container>
                             </div>
                         </ng-template>
                        </div>

                        <!-- Mobile hamburger menu -->
                        <div class="header__hamburger d-lg-none">
                            <div class="sidebar-menu" (click)="addmenu()">
                                <i class="fas fa-bars" [ngClass]="isFixed ? 'text-dark' : 'text-white'"></i>
                            </div>
                        </div>
                    </div>
                    <nav id="mobile-menu">
                        <ul class="main-nav"[ngClass]="{ 'active': isHovered }">
                        <ng-container *ngFor="let mainMenus of header">
                            <ng-container *ngIf="mainMenus.separateRoute === true">
                            <li class="has-submenu megamenu" [class.active]="base===mainMenus.base || base===mainMenus.base1 || base===mainMenus.base2 || base===mainMenus.base3 || base===mainMenus.base4 || base===mainMenus.base5 || base===mainMenus.base6" (mouseenter)="isHovered = true"  (mouseleave)="isHovered = false">
                                <a href="javascript:void(0);">{{mainMenus.tittle}} <i [ngClass]="base==='index'? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'"></i></a>
                                <ul class="submenu mega-submenu">
                                    <li>
                                        <div class="megamenu-wrapper">
                                            <div class="d-none d-lg-flex align-items-center justify-content-between flex-wrap">
                                                <h6 class="mb-3">Home Pages</h6>
                                                <a href="javascript:void(0);" class="btn btn-dark btn-md mb-3 text-white d-inline-block w-auto">Purchase Template</a>
                                            </div>
                                            <div class="row g-lg-4">
                                            <ng-container *ngFor="let menu of mainMenus.menu">
                                                <div class="col-lg-2">
                                                    <div class="single-demo" [class.active]="base === menu.base">
                                                        <div class="demo-img">
                                                            <a [routerLink]="menu.route"><img [src]="menu.img" class="img-fluid" alt="img" /></a>
                                                        </div>
                                                        <div class="demo-info">
                                                            <a [routerLink]="menu.route">{{menu.homeName}}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            </ng-container>
                            <ng-container *ngIf="mainMenus.separateRoute === false">
                            <ng-container *ngIf="mainMenus.twoTitle === false">
                                <li class="has-submenu mega-innermenu" [class.active]="base===mainMenus.base">
                                <a [routerLink]="mainMenus.route">{{mainMenus.tittle}} <i [ngClass]="base==='index'? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'"></i></a>
                                <ul class="submenu mega-submenu">
                                    <li>
                                        <div class="megamenu-wrapper">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <h6>{{mainMenus.subTitle}}</h6>
                                                    <ul>
                                                        <ng-container *ngFor="let menu of mainMenus.menu">
                                                        <li [class.active]="base===menu.base || page === menu.base"><a [routerLink]="menu.route">{{menu.menuValue}}</a></li>
                                                        </ng-container>
                                                    </ul>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="menu-img">
                                                        <img [src]="mainMenus.img" class="img-fluid" alt="img" >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                </li>
                            </ng-container>
                            <ng-container *ngIf="mainMenus.twoTitle === true">
                                <li class="has-submenu mega-innermenu" [class.active]="base===mainMenus.base || base===mainMenus.base1 || base===mainMenus.base2">
                                <a href="javascript:void(0);">{{mainMenus.tittle}} <i [ngClass]="base==='index'? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'"></i></a>
                                            <ul class="submenu mega-submenu">
                                                <li>
                                                    <div class="megamenu-wrapper">
                                                        <div class="row g-lg-4">
                                                            <div class="col-lg-6">
                                                                <h6>{{mainMenus.subTitle}}</h6>
                                                                <ul>
                                                                    <ng-container *ngFor="let menu of mainMenus.menu">
                                                                    <ng-container  *ngIf="menu.menuValue">
                                                                        <li [class.active]="page===menu.base"><a [routerLink]="menu.route">{{menu.menuValue}}</a></li>
                                                                    </ng-container>
                                                                </ng-container>
                                                                </ul>
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <h6>{{mainMenus.subTitle2}}</h6>
                                                                <ul>
                                                                <ng-container *ngFor="let menu of mainMenus.menu">
                                                                    <ng-container  *ngIf="menu.menuValue2">
                                                                        <li [class.active]="page===menu.base"><a [routerLink]="menu.route">{{menu.menuValue2}}</a></li>
                                                                    </ng-container>
                                                                </ng-container>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                </li>
                            </ng-container>
                            </ng-container>
                        </ng-container>

                    </ul>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</div>


 <ng-template #authenicatedMenu>
  <ng-container *ngIf="authService.isLoggedIn$ | async">
    <div *ngIf="authService.currentUser$ | async as user" class="dropdown profile-dropdown">
        <a href="javascript:void(0);" class="d-flex align-items-center" data-bs-toggle="dropdown">
            <span class="mx-2 mx-md-3 text-white user-name d-none d-sm-inline">Hi, {{ user?.firstName}}</span>
            <span class="mx-2 mx-md-3 text-white user-name d-sm-none">{{ user?.firstName}}</span>
            <span class="avatar avatar-sm avatar-md-md">
            <img src="assets/img/users/user-05.jpg" alt="Img" class="img-fluid rounded-circle border border-white border-2 border-md-4">
          </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-2 p-md-3 mobile-dropdown-menu">
            <li *ngIf="authService.isAdmin$ | async">
              <a class="dropdown-item d-inline-flex align-items-center rounded fw-medium p-2 mobile-dropdown-item" [routerLink]="routes.adminDashboard">
                <i class="fas fa-tachometer-alt me-2"></i>
                Admin Dashboard
              </a>
            </li>
            <li>
                <a class="dropdown-item d-inline-flex align-items-center rounded fw-medium p-2 mobile-dropdown-item" [routerLink]="routes.customerHotelBooking">
                  <i class="fas fa-calendar-check me-2"></i>
                  My Booking
                </a>
            </li>
            <li>
                <a class="dropdown-item d-inline-flex align-items-center rounded fw-medium p-2 mobile-dropdown-item" [routerLink]="routes.myProfile">
                  <i class="fas fa-user me-2"></i>
                  My Profile
                </a>
            </li>
            <li>
                <hr class="dropdown-divider my-2">
            </li>
            <!-- <li>
                <a class="dropdown-item d-inline-flex align-items-center rounded fw-medium p-2 mobile-dropdown-item" [routerLink]="routes.profileSettings">
                  <i class="fas fa-cog me-2"></i>
                  Settings
                </a>
            </li> -->
            <li>
                <a class="dropdown-item d-inline-flex align-items-center rounded fw-medium p-2 mobile-dropdown-item text-danger" (click)="logout()">
                  <i class="fas fa-sign-out-alt me-2"></i>
                  Logout
                </a>
            </li>
        </ul>
    </div>
   </ng-container>
 </ng-template>

 <ng-template #mobileAuthenticatedMenu>
  <ng-container *ngIf="authService.isLoggedIn$ | async">
    <div *ngIf="authService.currentUser$ | async as user" class="mobile-user-menu">
        <div class="d-flex align-items-center mb-3 p-3 bg-dark rounded">
            <span class="avatar avatar-md me-3">
                <img src="assets/img/users/user-05.jpg" alt="Img" class="img-fluid rounded-circle border border-white border-2">
            </span>
            <div class="text-white">
                <div class="fw-medium">Hi, {{ user?.firstName}}</div>
                <small class="text-light opacity-75">{{ user?.email }}</small>
            </div>
        </div>
        <div class="mobile-menu-links">
            <div *ngIf="authService.isAdmin$ | async" class="mb-2">
              <a class="btn btn-outline-light w-100 d-flex align-items-center justify-content-start" [routerLink]="routes.adminDashboard" (click)="closeMenu()">
                <i class="fas fa-tachometer-alt me-2"></i>
                Admin Dashboard
              </a>
            </div>
            <div class="mb-2">
                <a class="btn btn-outline-light w-100 d-flex align-items-center justify-content-start" [routerLink]="routes.customerHotelBooking" (click)="closeMenu()">
                  <i class="fas fa-calendar-check me-2"></i>
                  My Booking
                </a>
            </div>
            <div class="mb-2">
                <a class="btn btn-outline-light w-100 d-flex align-items-center justify-content-start" [routerLink]="routes.myProfile" (click)="closeMenu()">
                  <i class="fas fa-user me-2"></i>
                  My Profile
                </a>
            </div>
            <div class="mb-2">
                <a class="btn btn-danger w-100 d-flex align-items-center justify-content-start" (click)="logout(); closeMenu()">
                  <i class="fas fa-sign-out-alt me-2"></i>
                  Logout
                </a>
            </div>
        </div>
    </div>
   </ng-container>
 </ng-template>

